import { createReducer } from "reduxsauce";

import ReducerRegister from "../../../../ReducerRegister";

import UIDs from "../../../../../UIDs";

const uid = UIDs.screens.admin.partner.user.add;

//
// Actions
//
const Actions = {
    
};

//
// Initial State
//
const INITIAL_STATE = {
    
};

//
// Reducers
//



// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { Actions, reducer, INITIAL_STATE };
